// extracted by mini-css-extract-plugin
module.exports = {"main_title":"Blog_main_title__1_FVo","person":"Blog_person__1XvCg","photo":"Blog_photo__2LLs5","text":"Blog_text__2B8el","name":"Blog_name__xFpz-"};